/**
 * @file getOragizationQuery
 *
 * @fileoverview Gets the organization queries. The optional flags are checked as well..
 */
import { gql } from '@apollo/client';
import CUSTOM_ORGANIZATION_FIELDS from '~/graphql/queries/organization/customOrganizationFields.gql';
import ORGANIZATION_FRAGMENT from '~/jobiqo/components/Organization/fragments/organizationFragment.gql';
import ORGANIZATION_MINISITE_FRAGMENT from '~/jobiqo/components/Organization/fragments/organizationMinisiteFragment.gql';
import BLOG_POST_FRAGMENT from '~/jobiqo/pages/blogs/graphql/fragments/blogPostFragment.gql';

export const getOrganizationProfileByIdQuery = () => {
  return gql`
    ${ORGANIZATION_FRAGMENT}
    ${CUSTOM_ORGANIZATION_FIELDS}
    query organizationProfileById($id: Int!) {
      organizationProfileById(id: $id) {
        errors
        content {
          ... on OrganizationProfile {
            ...OrganizationFragment
            ...CustomOrganizationFields
          }
        }
      }
    }
  `;
};

export const getOrganizationProfileByPathQuery = (
  minisiteEnabled = false,
  blogEnabled = false,
) => {
  return gql`
    ${ORGANIZATION_FRAGMENT}
    ${minisiteEnabled ? ORGANIZATION_MINISITE_FRAGMENT : ''}
    ${blogEnabled ? BLOG_POST_FRAGMENT : ''}
    ${CUSTOM_ORGANIZATION_FIELDS}
    query organizationProfileByPath($path: String!, $language: String) {
      organizationProfileByPath(path: $path, language: $language) {
        errors
        ... on ErrorResponse {
          code
          reason
          errors
        }
        ... on ContentResponse {
          content {
            ... on OrganizationProfile {
              ...OrganizationFragment
              ...CustomOrganizationFields
              ${minisiteEnabled ? '...OrganizationMinisiteFragment' : ''}
              ${blogEnabled ? 'blogPosts { ...BlogPostFragment }' : ''}
            }
          }
        }
      }
      route(path: $path) {
        ... on ErrorResponse {
          code
        }
        ... on RedirectResponse {
          code
          target
        }
      }
    }
  `;
};

export const getOrganizationProfileByUserIdQuery = () => {
  return gql`
    ${CUSTOM_ORGANIZATION_FIELDS}
    query organizationProfileByUserId($id: Int!) {
      organizationProfileByUserId(id: $id) {
        errors
        content {
          ... on OrganizationProfile {
            frontends
            workflowState {
              value
            }
            ...CustomOrganizationFields
          }
        }
      }
    }
  `;
};

export const getAgencyOrganizations = () => {
  return gql`
    query getAgencyOrganizations($id: Int!) {
      getAgencyOrganizations(id: $id) {
        ... on Organization {
          name
          id
        }
      }
    }
  `;
};
